import TableToExcel from '@linways/table-to-excel';
import download from 'downloadjs';

export const buildExportFilename = (prefix, ext) => {
  const date = new Date().toISOString().split('T')[0];
  return `${prefix}_export_${date}.${ext}`;
};

// Prefix a leading =/+/-/@ with a quote so Excel/Sheets won't run it as a formula.
const escapeFormulaInjection = (value) => {
  const str = String(value);
  return /^[=+\-@]/.test(str) ? `'${str}` : str;
};

export const exportRowsToCSV = (headers, rows, filename) => {
  const csv = [headers, ...rows]
    .map((row) => row.map((cell) => `"${escapeFormulaInjection(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  download(csv, filename, 'text/csv');
};

export const exportTableToFile = (tableId, filename, sheetName) => {
  const table = document.getElementById(tableId);
  if (!table) return;
  TableToExcel.convert(table, {
    name: filename,
    sheet: { name: sheetName },
  });
};
